import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import SplitPane from 'react-split-pane'
import { editPaneWidthHeight } from '../../../../utils/adjustPane'
import { debounce } from '../../../../utils/debounce'
import Input from '../../views/Input/Input'
import Output from '../../views/Output/Output'

const DesktopView = () => {
  const myRef = useRef(null)
  const { orientation /*, mediaClass */ } = useSelector((state) => state.settings)

  let mediaClass = '-media-md'
  // const minSize = getSplitpaneMinSize('-media-md')

  useEffect(() => {
    adjustPaneWidthHeight()
  }, [orientation])


  const adjustPaneWidthHeight = () => {
    let panes = document.getElementsByClassName('Pane1')
    editPaneWidthHeight(panes[0], orientation, 'Pane1')
    panes = document.getElementsByClassName('Pane2')
    editPaneWidthHeight(panes[0], orientation, 'Pane2')
  }

  const handleDragging = debounce(adjustPaneWidthHeight, 200)

  useEffect(() => {
    mediaClass = window.innerWidth < 1600 ? '-media-md' : '-media-lg'
    document.documentElement.classList.remove('-media-xs', '-media-sm', '-media-md', '-media-lg')
    document.documentElement.classList.add(mediaClass)
  }, [])

  return (
    <SplitPane
      ref={myRef}
      defaultSize="50%"
      split={orientation}
      minSize={mediaClass === '-media-md' ? 26 : 32}
      onChange={handleDragging}
    >
      <Input />
      <Output />
    </SplitPane>
  )
}

export default DesktopView
